import { render } from "./ReviewAndPayCard.vue?vue&type=template&id=4af01384&scoped=true"
import script from "./ReviewAndPayCard.vue?vue&type=script&lang=ts"
export * from "./ReviewAndPayCard.vue?vue&type=script&lang=ts"

import "./ReviewAndPayCard.vue?vue&type=style&index=0&id=4af01384&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4af01384"

export default script